/* eslint-disable no-await-in-loop */
import { message } from 'antd';

import Utils from '../../Assets/Scripts/Utils';
import { api } from '../../Services/axiosService';
import { deleteFileDocuments } from '../../Services/firebaseService';

export default class ScheduleUtils {
  static getCustomProductList() {
    return [
      '19852', // Elaboração de AVCB
      '19858', // Emissão de 2ª Via de Documentos - CT
      '324774', // Emissão de 2ª Via de Documentos - In Company
      '19902', // Laudo
      '19882', // Palestra SIPAT
      '19906', // Produto Personalizado - CT
      '310844', // Produto Personalizado - In Company
      '19884', // Renovação de AVCB
      '19886', // Serviço de Emissão de ART - CT
      '324776', // Serviço de Emissão de ART - In Company
      '211350', // Transporte
      '19900', // Visita Técnica - CT
      '324778', // Visita Técnica - In Company
      '325152', // Transporte Extra
    ];
  }

  /** Partes de workDays com trim; aceita string ou array (ex.: vindo serializado diferente). */
  static parseWorkDaysTokens(workDays) {
    if (workDays == null || workDays === '') return [];
    const raw = Array.isArray(workDays) ? workDays.join(',') : String(workDays);
    return raw
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t !== '');
  }

  /**
   * true = data fora do expediente (não é dia útil em workDays).
   * JS: domingo = 0; legado no projeto pode usar 7 para domingo.
   */
  static isBlocked(date, workDays) {
    const tokens = ScheduleUtils.parseWorkDaysTokens(workDays);
    if (tokens.length === 0) {
      // Compatível com workDays "" : split virava [''] e nenhum getDay() batia → tudo “bloqueado”
      return true;
    }
    const day = date.getDay();
    const dayKey = `${day}`;
    const isWorkDay = tokens.includes(dayKey) || (day === 0 && tokens.includes('7'));
    return !isWorkDay;
  }

  static isDisableDate(date, workDays) {
    return ScheduleUtils.isBlocked(date, workDays);
  }

  static isBlockedDay(date, blockedDates) {
    const localeDate = date.toLocaleDateString();
    return blockedDates.filter(({ blockedDay }) => blockedDay === localeDate).length > 0;
  }

  static isValidAppointment(component, appointmentData, workDays) {
    const startDate = new Date(appointmentData.startDate);
    const endDate = new Date(appointmentData.endDate);
    const cellDuration = component?.option('cellDuration');
    return ScheduleUtils.isValidAppointmentInterval(startDate, endDate, cellDuration, workDays);
  }

  static isValidAppointmentInterval(startDate, endDate, cellDuration, workDays) {
    const edgeEndDate = new Date(endDate.getTime() - 1);

    if (!ScheduleUtils.isValidAppointmentDate(edgeEndDate, workDays)) {
      return false;
    }

    const durationInMs = cellDuration * 60 * 1000;
    const date = startDate;
    while (date <= endDate) {
      if (!ScheduleUtils.isValidAppointmentDate(date, workDays)) {
        return false;
      }
      const newDateTime = date.getTime() + durationInMs - 1;
      date.setTime(newDateTime);
    }

    return true;
  }

  static isValidAppointmentDate(date, workDays) {
    return !ScheduleUtils.isBlocked(date, workDays);
  }

  static translateFlag(flag) {
    if (flag) {
      return 'Verdadeiro';
    }
    return 'Falso';
  }

  static async sendPushNotification(task, event, eventSource, receiverId) {
    try {
      let titleSource = '';
      let title = '';
      let body = '';
      let redirectUrlWeb = null;
      let redirectUrlMobile = null;
      const eventSourceFormatted = eventSource.charAt(0).toUpperCase() + eventSource.slice(1);

      switch (eventSourceFormatted) {
        case 'CT':
          titleSource = 'Centro de Treinamento';
          redirectUrlWeb = `/Agenda/CentroTreinamento/OpenTraining/${task.id}`;
          break;
        case 'MainInstructor':
          titleSource = 'Instrutor';
          redirectUrlWeb = `/Agenda/Instrutor/OpenTraining/MainInstructor/${task.id}`;
          redirectUrlMobile = `/Agenda/OpenTraining/${task.id}`;
          break;
        case 'AssistantInstructor':
          titleSource = 'Instrutor Auxiliar';
          redirectUrlWeb = `/Agenda/Instrutor/OpenTraining/AssistantInstructor/${task.id}`;
          redirectUrlMobile = `/Agenda/OpenTraining/${task.id}`;
          break;
        case 'Driver':
          titleSource = 'Motorista';
          redirectUrlWeb = `/Agenda/Motorista/OpenTraining/Driver/${task.id}`;
          redirectUrlMobile = `/Agenda/OpenTraining/${task.id}`;
          break;
        default:
          break;
      }

      switch (event) {
        case 'TaskDenied':
          title = `Treinamento Negado ${titleSource}`;
          body = `O ${titleSource} (${task[
            eventSource
          ]?.userName?.toUpperCase()}) negou o treinamento (${
            task.cardTitle
          }). Vincule um novo ${titleSource}!`;
          break;
        case 'TaskReceived':
          title = 'Treinamento Recebido';
          body = `Novo treinamento (${task.cardTitle}) recebido. Você pode clicar no botão de redirecionamento para ir até a agenda!`;
          break;
        case 'TaskRemoved':
          title = 'Treinamento Cancelado';
          body = `O treinamento (${task.cardTitle}) foi cancelado e removido da sua agenda!`;
          break;
        default:
          break;
      }

      const data = {
        sourceId: receiverId,
        sourceEvent: eventSource,
        notification: {
          userId: receiverId,
          title,
          body,
          redirectUrlPathWeb: redirectUrlWeb,
          redirectUrlPathMobile: redirectUrlMobile,
        },
      };

      if (event === 'TaskRemoved') {
        delete data.notification.redirectUrlPathWeb;
        delete data.notification.redirectUrlPathMobile;
      }

      await api.post('/Notification', data).then((res) => res);
    } catch (error) {
      Utils.logError(error);
      message.error('Erro ao enviar notificação!');
    }
  }

  static async sendPushNotificationToResponsible(task) {
    try {
      const [responsible] = await api
        .get('/User?filters[0].Field=BitrixId&filters[0].Condition=EQUAL&filters[0].Value=156')
        .then((res) => res.data);

      const data = {
        sourceId: responsible?.id,
        sourceEvent: 'Responsible',
        notification: {
          userId: responsible?.id,
          title: `Treinamento Negado`,
          body: `O Centro de Treinamento negou o treinamento (${task.cardTitle}).`,
          redirectUrlPathWeb: `/Agenda/Agendamento/OpenTraining/${task.id}`,
        },
      };

      await api.post('/Notification', data).then((res) => res);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao enviar a notificação ao Responsável do Treinamento!');
    }
  }

  static async sendNotificationToLogistics(task, eventSource, driverData, isAcceptance = true) {
    try {
      let titleSource = '';
      let sourceEvent = '';
      let title = '';
      let body = '';

      switch (eventSource) {
        case 'mainInstructor':
          titleSource = 'Instrutor';
          break;
        case 'assistantInstructor':
          titleSource = 'Instrutor Auxiliar';
          break;
        case 'driver':
          titleSource = 'Motorista';
          break;
        default:
          break;
      }

      if (eventSource === 'driver') {
        if (isAcceptance) {
          title = `Treinamento Aceito ${titleSource}`;
          body = `O ${titleSource} (${driverData?.userName?.toUpperCase()}) aceitou o treinamento (${
            task.cardTitle
          }). Você pode clicar no botão de redirecionamento para ir até a Agenda!`;
          sourceEvent = 'DriverTaskAccepted';
        } else {
          title = `Treinamento Negado ${titleSource}`;
          body = `O ${titleSource} (${driverData?.userName?.toUpperCase()}) negou o treinamento (${
            task.cardTitle
          }). Você pode clicar no botão de redirecionamento para ir até a Agenda!`;
          sourceEvent = 'DriverTaskDenied';
        }
      } else if (isAcceptance) {
        title = `Treinamento Aceito ${titleSource}`;
        body = `O ${titleSource} (${task[
          eventSource
        ]?.userName?.toUpperCase()}) aceitou o treinamento (${
          task.cardTitle
        }). Você pode clicar no botão de redirecionamento para ir até a Agenda!`;
        sourceEvent = 'InstructorTaskAccepted';
      } else {
        title = `Treinamento Negado ${titleSource}`;
        body = `O ${titleSource} (${task[
          eventSource
        ]?.userName?.toUpperCase()}) negou o treinamento (${
          task.cardTitle
        }). Você pode clicar no botão de redirecionamento para ir até a Agenda!`;
        sourceEvent = 'InstructorTaskDenied';
      }

      const receiversList = await api
        .get('/User?filters[0].Field=Role.Id&filters[0].Condition=NUMBER.EQUAL&filters[0].Value=39')
        .then((res) => res.data);

      for (let i = 0; i < receiversList.length; i += 1) {
        const userData = JSON.parse(localStorage.getItem('conecta__userData') ?? '{}');

        const data = {
          sourceId: userData?.id,
          sourceEvent,
          notification: {
            userId: receiversList[i].id,
            title,
            body,
            redirectUrlPathWeb: `/Agenda/Agendamento/OpenTraining/${task.id}`,
          },
        };

        await api.post('/Notification', data).then((res) => res);
      }
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Ocorreu um erro ao notificar a Logística!');
    }
  }

  static async sendTrainingHistory(taskID, taskTitle, taskStage, taskDate) {
    try {
      const data = {
        taskId: taskID,
        taskTitle,
        taskStage,
        date: taskDate,
      };
      await api.post('/TrainingHistory', data).then((res) => res);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar salvar o Histórico de Treinamento!');
    }
  }

  static async deleteAttachmentFromTask(docName, taskId) {
    await deleteFileDocuments(docName, 'trainings', taskId);
  }

  static toComparableTimestamp(value) {
    if (!value) {
      return null;
    }

    const time = new Date(value).getTime();
    return Number.isNaN(time) ? null : time;
  }

  static occupySameAgendaSlot(itemA, itemB) {
    if (itemA.startStamp === null || itemA.endStamp === null) {
      return false;
    }

    return (
      itemA.startStamp === itemB.startStamp &&
      itemA.endStamp === itemB.endStamp &&
      itemA.resource === itemB.resource
    );
  }

  static compareSlotKeys(itemA, itemB) {
    const startDiff = (itemA.startStamp ?? 0) - (itemB.startStamp ?? 0);
    if (startDiff !== 0) {
      return startDiff;
    }

    const endDiff = (itemA.endStamp ?? 0) - (itemB.endStamp ?? 0);
    if (endDiff !== 0) {
      return endDiff;
    }

    const resourceA = String(itemA.resource ?? 'null');
    const resourceB = String(itemB.resource ?? 'null');
    if (resourceA === resourceB) {
      return 0;
    }

    return resourceA < resourceB ? -1 : 1;
  }

  static compareSharedSlotEnqueueOrder(itemA, itemB) {
    if (!ScheduleUtils.occupySameAgendaSlot(itemA, itemB)) {
      const slotOrder = ScheduleUtils.compareSlotKeys(itemA, itemB);
      if (slotOrder !== 0) {
        return slotOrder;
      }

      return itemA.originalIndex - itemB.originalIndex;
    }

    const schedulingA = itemA.schedulingStamp ?? Number.POSITIVE_INFINITY;
    const schedulingB = itemB.schedulingStamp ?? Number.POSITIVE_INFINITY;

    if (schedulingA !== schedulingB) {
      return schedulingA - schedulingB;
    }

    return itemA.originalIndex - itemB.originalIndex;
  }

  static readTooltipAppointmentRecord(itemData) {
    if (!itemData) {
      return {};
    }

    if (itemData.appointmentData) {
      return itemData.appointmentData;
    }

    if (itemData.data?.appointmentData) {
      return itemData.data.appointmentData;
    }

    return itemData;
  }

  static readAppointmentTooltipKey(itemData) {
    const appointmentRecord = ScheduleUtils.readTooltipAppointmentRecord(itemData);
    if (appointmentRecord?.id == null) {
      return '';
    }

    return String(appointmentRecord.id);
  }

  static readClickedAppointmentId(schedulerEvent) {
    return schedulerEvent?.appointmentData?.id ?? null;
  }

  static mapAppointmentsForSlotSort(appointmentList) {
    return appointmentList.filter(Boolean).map((appointment, originalIndex) => ({
      appointment,
      originalIndex,
      startStamp: ScheduleUtils.toComparableTimestamp(appointment.startDate),
      endStamp: ScheduleUtils.toComparableTimestamp(appointment.endDate),
      schedulingStamp: ScheduleUtils.toComparableTimestamp(appointment.dateScheduling),
      resource: appointment.resourceId ?? null,
    }));
  }

  static assignSlotStackPositions(listWithIndex) {
    const slotStackCounters = new Map();

    return listWithIndex.map((item) => {
      if (item.startStamp === null || item.endStamp === null) {
        return { ...item, slotStackPosition: 0 };
      }

      const groupKey = `${item.startStamp}-${item.endStamp}-${item.resource ?? 'null'}`;
      const currentStack = slotStackCounters.get(groupKey) ?? 0;
      slotStackCounters.set(groupKey, currentStack + 1);

      return { ...item, slotStackPosition: currentStack };
    });
  }

  static sortAppointmentsBySlotEnqueueOrder(appointmentList = []) {
    const listWithIndex = ScheduleUtils.mapAppointmentsForSlotSort(appointmentList);
    listWithIndex.sort(ScheduleUtils.compareSharedSlotEnqueueOrder);
    const listWithStack = ScheduleUtils.assignSlotStackPositions(listWithIndex);

    return listWithStack.map(({ appointment, slotStackPosition = 0 }, index) => ({
      ...appointment,
      index,
      slotStackPosition,
    }));
  }
}
